export const backendURL = 'https://api.medinfobook.gr/' //'http://192.168.1.152:666/'
export const authBackendURL = 'https://auth.medinfobook.gr/' //'http://192.168.1.152:888/' 
export const websocketURL= 'wss://auth.medinfobook.gr/socket'       // "ws://192.168.1.150:4000"
export const Feature_Toggles = {
    'tutorial': true,
    'checkup': true,
}
